// JSON-LD-hjälpare separerade från presentationskomponenterna (SeoPage,
// Breadcrumbs). Rutternas head() importerar bara dessa funktioner, vilket gör
// att de tunga komponenterna kan kodsplittas i stället för att ligga i
// startbundlen.
export function stripTags(s: string): string {
  return s.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
}

export function faqJsonLd(faqs: { q: string; a: string }[], datePublished = "2026-01-15") {
  const dateIso = new Date(`${datePublished}T08:00:00+01:00`).toISOString();
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      inLanguage: "sv-SE",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: stripTags(f.q),
        datePublished: dateIso,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: stripTags(f.a),
          datePublished: dateIso,
          upvoteCount: 1,
        },
      })),
    }),
  };
}

export function articleJsonLd(args: {
  url: string;
  headline: string;
  description: string;
  datePublished?: string;
  dateModified?: string;
  image?: string;
}) {
  const image = args.image ?? "https://alkoholprovet.se/og-image.png";
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Article",
      inLanguage: "sv-SE",
      headline: args.headline.slice(0, 110),
      description: args.description,
      image: [image],
      mainEntityOfPage: { "@type": "WebPage", "@id": args.url },
      author: { "@type": "Organization", name: "Alkoholprovet", url: "https://alkoholprovet.se" },
      publisher: {
        "@type": "Organization",
        name: "Alkoholprovet",
        logo: { "@type": "ImageObject", url: "https://alkoholprovet.se/icon-192.png" },
      },
      datePublished: args.datePublished ?? args.dateModified ?? "2026-06-10",
      dateModified: args.dateModified ?? args.datePublished ?? "2026-06-10",
    }),
  };
}

export function breadcrumbJsonLd(items: { label: string; url: string }[]) {
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.label,
        item: it.url,
      })),
    }),
  };
}
